module.exports = __webpack_public_path__ + "static/media/tree-palm.f4596bf4.svg";